import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { ImageSquare, X } from "@phosphor-icons/react";

export function PhotoTile({ fileId, onRemove, canRemove, size = "sm" }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let blobUrl;
    (async () => {
      try {
        const res = await http.get(`/files/${fileId}`, { responseType: "blob", validateStatus: () => true });
        if (cancelled) return;
        if (res.status >= 200 && res.status < 300 && res.data) {
          blobUrl = URL.createObjectURL(res.data);
          setUrl(blobUrl);
        } else {
          setFailed(true);
        }
      } catch (e) {
        console.error("[photo-tile] fetch failed", e);
        if (!cancelled) setFailed(true);
      }
    })();
    return () => { cancelled = true; if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [fileId]);

  const cls = size === "lg" ? "aspect-video" : "aspect-square";
  return (
    <div className={`relative ${cls} border border-slate-200 rounded-md overflow-hidden bg-slate-50 group`} data-testid={`photo-tile-${fileId}`}>
      {url ? (
        <img src={url} alt="" className="h-full w-full object-cover" />
      ) : failed ? (
        <div className="h-full w-full flex flex-col items-center justify-center text-slate-300 gap-1">
          <ImageSquare size={20} />
          <span className="text-[9px] uppercase tracking-wider">Missing</span>
        </div>
      ) : (
        <div className="h-full w-full flex items-center justify-center text-slate-300"><ImageSquare size={28} /></div>
      )}
      {canRemove && (
        <button onClick={() => onRemove(fileId)} data-testid={`photo-remove-${fileId}`}
          className="absolute top-1 right-1 h-6 w-6 rounded-sm bg-white/90 border border-slate-200 opacity-0 group-hover:opacity-100 transition flex items-center justify-center hover:bg-rose-50 hover:text-rose-600">
          <X size={12} />
        </button>
      )}
    </div>
  );
}
